// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-module--logo--1BHSa","wrapper":"Logo-module--wrapper--3-Pzw","inner":"Logo-module--inner--1UnYr","secondary":"Logo-module--secondary--2GqsF"};